export default defineAppConfig({
  javaskit: {
    currency: {
      maximumFractionDigits: 2,
    },
    percent: {
      maximumFractionDigits: 0,
    },
    theme: {
      aform: {
        submit: 'mt-6 flex items-center gap-4',
      },
    },
  },
})
